export class Contrast {
  static root = document.querySelector(':root')! as HTMLElement;
  static rootStyle = getComputedStyle(Contrast.root);
  static observer: MutationObserver;
  static isOn = false;

  static vars = [
    { name: '--brand-color', value: '#BF2D91' },
    { name: '--brand-color-dark', value: '#000' },
    { name: '--brand-color-light', value: '#BF2D91' },
    { name: '--brand-color-white', value: '#fff' },
    { name: '--brand-exhibitorstrip-color', value: '#000' },
    { name: '--brand-color-good', value: 'red' },
    { name: '--brand-color-bad', value: 'red' },
    { name: '--brand-color-error', value: 'red' },
    { name: '--brand-color-progress', value: 'red' },
    { name: '--brand-available-color', value: 'red' },
    { name: '--brand-busy-color', value: 'red' },
    { name: '--brand-other-busy-color', value: 'red' },
    { name: '--background-color-white', value: '#000' },
    { name: '--background-color-light', value: '#000' },
    { name: '--background-color-grey', value: '#000' },
    { name: '--background-color-offwhite', value: '#000' },
    { name: '--background-color-offblack', value: '#000' },
    { name: '--background-color-dark', value: '#000' },
    { name: '--background-color-black', value: '#000' },
    { name: '--background-color-live-button', value: '#fff' },
    { name: '--color-live-button', value: '#000' },
    { name: '--text-color-black', value: '#fff' },
    { name: '--text-color-light-black', value: '#fff' },
    { name: '--text-color-darker', value: '#fff' },
    { name: '--text-color-darker-grey', value: '#fff' },
    { name: '--text-color-grey', value: '#fff' },
    { name: '--text-color-light-grey', value: '#fff' },
    { name: '--text-color-white', value: '#fff' },
  ];

  static elements = [
    '[tabindex="0"]',
    'input',
    '[role="comment"]',
    '[role="link"]',
    'textarea',
    '.message_wrapper .message_child',
    '#popup_container',
    '.contrast',
    '#contents',
    '#centered_container',
    '.svg_contrast',
    '#icon',
    'svg',
    'path',
    '#topnav',
    'g',
    '.x_button',
  ];

  static toggle = function () {
    if (Contrast.isOn) {
      Contrast.disableHighContrastTheme();
    } else {
      Contrast.setHighContrastTheme();
    }
  };

  static disableHighContrastTheme() {
    Contrast.elements.forEach(selector => {
      Array.from(document.querySelectorAll(selector) as unknown as HTMLCollectionOf<HTMLElement>).forEach(node => {
        if (node.nodeName === 'IMG') {
          node.style.removeProperty('filter');
        } else if (node.nodeName === 'svg' || node.nodeName === 'path' || node.nodeName === 'g') {
          node.style.removeProperty('fill');
        } else if (selector === '.svg_contrast') {
          node.style.removeProperty('fill');
        } else {
          node.style.removeProperty('background-color');
          node.style.removeProperty('border');
          node.style.removeProperty('padding');
          node.style.removeProperty('border-radius');
        }
      });
    });
    Contrast.vars.forEach(colorVar => {
      Contrast.root.style.removeProperty(colorVar.name);
    });
    Contrast.isOn = false;
  }

  static applyContrast(node: HTMLElement) {
    let allStyles = window.getComputedStyle(node);
    if (node.style.backgroundColor !== 'var(--brand-color)') {
      node.style.setProperty('background-color', 'var(--background-color-black)', 'important');
    }
    if (node.style.border !== '2px solid var(--brand-color)') {
      node.style.setProperty('border', '2px solid var(--text-color-white)', 'important');
      node.style.setProperty('border-radius', '0', 'important');
      //node.style.setProperty('border-radius', '5px');
    }

    if (
      (allStyles.paddingRight === '0px' &&
        allStyles.paddingLeft === '0px' &&
        allStyles.paddingTop === '0px' &&
        allStyles.paddingBottom === '0px') ||
      allStyles.padding === '0px'
    ) {
      node.style.setProperty('padding', '2px');
    }
  }

  static applyContrastSVG(node: HTMLElement) {
    // node.style.setProperty('stroke', 'white');
    if (node.nodeName === 'svg' || node.nodeName === 'path' || node.nodeName === 'g') {
      node.style.setProperty('fill', 'white', 'important');
    } else if (node.nodeName !== 'svg') {
      Array.from(node.getElementsByTagName('SVG') as HTMLCollectionOf<HTMLElement>)[0].style.setProperty(
        'fill',
        'white',
        'important',
      );
    }
  }

  static applyContrastImg(node: HTMLElement) {
    node.style.setProperty('filter', 'brightness(0) invert(1)');
  }

  static domLoop() {
    Contrast.elements.forEach(selector => {
      Array.from(document.querySelectorAll(selector) as unknown as HTMLCollectionOf<HTMLElement>).forEach(node => {
        if (node.nodeName === 'IMG') {
          Contrast.applyContrastImg(node);
        } else if (node.nodeName === 'svg' || node.nodeName === 'path' || node.nodeName === 'g') {
          Contrast.applyContrastSVG(node);
        } else {
          Contrast.applyContrast(node);
        }
      });
    });
  }

  static setHighContrastTheme() {
    Contrast.vars.forEach(colorVar => {
      Contrast.root.style.setProperty(colorVar.name, colorVar.value);
    });
    Contrast.isOn = true;
    Contrast.domLoop();
    Contrast.observer = new MutationObserver(() => {
      if (document.body && Contrast.isOn) {
        Contrast.domLoop();
      }
    });
    Contrast.observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
}
